import { useParams, Navigate } from 'react-router-dom';
import { ItineraryView } from '@/components/itinerary/ItineraryView';
import { preBuiltItineraries } from '@/app/lib/pre-built-itineraries';
import { addDays, format } from 'date-fns';
import type { Itinerary } from '@/app/lib/types';

export default function PreBuiltItineraryPage() {
  const { slug } = useParams<{ slug: string }>();
  const itineraryData = preBuiltItineraries.find((i) => i.slug === slug);

  if (!itineraryData) {
    return <Navigate to="/itinerary/discover" replace />;
  }

  const startDate = new Date();
  
  // Create a full Itinerary object that matches the structure expected by ItineraryView
  const fullItineraryObject: Itinerary = {
    id: itineraryData.slug,
    userProfileId: '', // No user for pre-built
    name: itineraryData.itinerary.title,
    startDate: startDate.toISOString(),
    endDate: addDays(startDate, itineraryData.formValues.duration - 1).toISOString(),
    preferences: itineraryData.formValues.preferences,
    skillLevel: itineraryData.formValues.skillLevel,
    duration: itineraryData.formValues.duration,
    location: itineraryData.formValues.location,
    generatedItinerary: {
        ...itineraryData.itinerary,
        days: itineraryData.itinerary.days.map(day => ({
            ...day,
            date: format(addDays(startDate, day.day - 1), 'yyyy-MM-dd')
        }))
    },
    notes: [],
    todos: [],
  };


  return (
    <div className="container mx-auto">
        <ItineraryView
          itinerary={fullItineraryObject}
          isEditable={false}
          preBuiltFormValues={itineraryData.formValues}
        />
    </div>
  );
}
